import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-scora-toast-module',
  templateUrl: './scora-toast-module.component.html',
  styleUrls: ['./scora-toast-module.component.css']
})
export class ScoraToastModuleComponent implements OnInit {

  @Input() notificationMessage: any;
  @Output() noEventCall = new EventEmitter<any>();
  @Output() yesEventCall = new EventEmitter<any>();
  @Output() closeModel = new EventEmitter<any>();

  constructor() { }


  ngOnChanges(){

    // if(this.notificationMessage.isButton){
    // }else{
    if (this.notificationMessage == undefined) {
      
    }else{
      
        if(this.notificationMessage.isButton){
        }else{
          if (this.notificationMessage.message != undefined && this.notificationMessage.message != null) {
            if (this.notificationMessage.message.length > 0) {
                setTimeout(() => {
              this.notificationMessage ={}
            }, 5000);
            }
            
          }
         
       
      }
    }
  
 
    // }
 
  }

  ngOnInit() {
    // this.dataShear.$sharedData.subscribe((doc:any) =>{
    //   this.notificationMessage = doc;

    //   setTimeout(() => {
    //     this.notificationMessage ={}
    //   }, 5000);
    // })
  }

  forTostNotification(data:any) {
    console.log(data)
    this.notificationMessage.message = data.message;
    this.notificationMessage.type = data.type;
    this.notificationMessage.title = data.title != undefined ? data.title : '';
    this.notificationMessage.isButton = data.isButton;
    console.log(this.notificationMessage)
    if(this.notificationMessage.isButton){

    }else{
      setTimeout(() => {
        this.notificationMessage ={}
      }, 5000);
    }
  
  }

  closePopup() {
    if (this.notificationMessage.title == 'Empty results.') {
        this.closeModel.emit('close')
    }
    document.querySelector(".overlay").classList.add("hidden");
    this.notificationMessage ={}
  }

  getColor(data){
    if (data.type === 'worning') return '#FFBE00 !important';
    if (data.type === 'info') return '#0E497A !important';
    if (data.type === 'success') return '#1BBC9B !important';
    if (data.type === 'error') return '#FF5252 !important';
    return 'black'; // Default color
  }

  getBGColor(data){
    if (data.type === 'worning') return '#FFF8EC !important';
    if (data.type === 'info') return '#F1F8FD !important';
    if (data.type === 'success') return '#F6FFF9 !important';
    if (data.type === 'error') return '#FFF5F3 !important';
    return 'black'; // Default color
  }

  getBColor(data){
    console.log(data)
    if (data.type == 'worning') return '#FFF8EC !important';
    if (data.type == 'info') return '#F1F8FD !important';
    if (data.type == "success") return '#1BBC9B !important';
    if (data.type == 'error') return '#FFF5F3 !important';
    return 'black'; // Default color
  }

  noEvent(){
    this.notificationMessage ={}
    this.noEventCall.emit('no')
  }
  yesEvent(){
    this.notificationMessage ={}
    this.yesEventCall.emit('yes')
  }
}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-toast-module/scora-toast-module.component.ts